import {
  ButtonField,
  Tooltip,
  TooltipBody,
} from '@wk/components-react16';
import { IconDownload, IconLoader2 } from '@tabler/icons-react';

import * as SiteComplianceContentSection from './SiteComplianceContent';
import * as SiteComplianceFiltersPanel from './SiteComplianceFilters';
import * as SiteCompliancePaginationBar from './SiteCompliancePagination';
import RunEvaluationDialog from '../../components/RunEvaluationDialog';
import { useSiteComplianceController } from './useSiteComplianceController';

import './SiteCompliancePage.css';

const SiteCompliancePage = () => {
  const {
    contentProps,
    filtersProps,
    isExporting,
    isMobileViewport,
    onExportSites,
    paginationProps,
    runEvaluationProps,
  } = useSiteComplianceController();

  return (
    <div className="site-compliance-page flex w-full flex-col gap-3 sm:h-full sm:gap-4">
      <div className="flex w-full items-center justify-between gap-x-4 gap-y-2 max-sm:flex-wrap">
        <div className="flex w-full items-center justify-between sm:w-auto">
          <h1 className="text-2xl font-bold">Site Compliance</h1>
          {isMobileViewport ? (
            <div className="flex items-center gap-2">
              <ButtonField mode="text">
                <button
                  type="button"
                  aria-label="Export site compliance to CSV"
                  onClick={onExportSites}
                  disabled={isExporting}
                >
                  {isExporting ? (
                    <IconLoader2 className="animate-spin" size={18} />
                  ) : (
                    <IconDownload size={18} />
                  )}
                </button>
              </ButtonField>
            </div>
          ) : null}
        </div>

        {!isMobileViewport ? (
          <div className="flex items-center justify-end gap-4 max-sm:w-full max-sm:flex-col max-sm:items-stretch">
            <Tooltip position="top" targetSelector="#export-site-compliance">
              <TooltipBody slot="tooltipBody">
                Exporting to CSV will only export the filtered sites.
              </TooltipBody>
            </Tooltip>
            <ButtonField mode="ghost">
              <button
                id="export-site-compliance"
                onClick={onExportSites}
                disabled={isExporting}
                className="site-compliance-export-button"
              >
                Export to CSV
                {isExporting ? (
                  <IconLoader2 className="animate-spin" size={16} />
                ) : null}
              </button>
            </ButtonField>
          </div>
        ) : null}
      </div>

      <SiteComplianceFiltersPanel.default {...filtersProps} />

      <div className="cg-ag-grid-field ag-theme-balham mt-2 flex w-full flex-col gap-4 sm:mt-5 sm:flex-1 sm:min-h-0">
        <SiteComplianceContentSection.default {...contentProps} />

        <div className="site-compliance-pagination">
          <SiteCompliancePaginationBar.default {...paginationProps} />
        </div>
      </div>
      <RunEvaluationDialog {...runEvaluationProps} />
    </div>
  );
};

export default SiteCompliancePage;
